<template>
  <v-card>
    <v-card-title>
      Schedule
    </v-card-title>
    <v-card-text>
      <v-skeleton-loader
        v-if="loading"
        type="table"
      />
      <div
        v-else
      >
        <p>
          Each team has
          <SecondsToMinutes
            :seconds="presentationTimeSeconds"
          />
          to present, with
          <SecondsToMinutes
            :seconds="bufferSeconds"
          />
          between presentations
        </p>
        <v-data-table
          :headers="headers"
          :items="schedule"
        >
          <template v-slot:item.start="{ item }">
            {{ getTime(item.start) }}
          </template>
          <template v-slot:item.end="{ item }">
            {{ getTime(item.end) }}
          </template>
          <template v-slot:item.team="{ item }">
            {{ getName(item.team) }}
          </template>
        </v-data-table>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import EventsClient from '@/api/EventsClient';
import SecondsToMinutes from '@/components/SecondsToMinutes.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'Schedule',
  components: {
    SecondsToMinutes,
  },
  data() {
    return {
      loading: true,
      schedule: [],
      bufferSeconds: null,
    };
  },
  computed: {
    ...mapGetters({
      currentJwtToken: 'currentJwtToken',
      presentationTimeSeconds: 'presentationTimeSeconds',
      eventId: 'currentHackathonId',
    }),
    headers() {
      return [
        { text: 'Start', value: 'start' },
        { text: 'End', value: 'end' },
        { text: 'Team', value: 'team' },
      ];
    },
  },
  mounted() {
    this.getSchedule();
  },
  methods: {
    async getSchedule() {
      const client = new EventsClient(this.currentJwtToken);
      const response = await client.getSchedule(this.eventId);
      this.schedule = response.schedule;
      this.bufferSeconds = response.presentationBufferSeconds;
      this.loading = false;
    },
    getTime(t) {
      const d = new Date(t);
      return d.toLocaleTimeString();
    },
    getName(t) {
      if (t === undefined) {
        return 'Break';
      }
      return t.name;
    },
  },
};
</script>
